<template>
<div class="mr15">
  <sui-page>
    <sui-page-contents>
      <sui-pager :totalPageCount="totalPageCount" :pagerLength="pagerLength" @page-changed="onPageChanged" />
      <div v-for="count in counts" class='row'>
        <button type="button" class="btn" @click="onCountClick(count)">{{count}}</button>
      </div>
    </sui-page-contents>
  </sui-page>
</div>
</template>
<script>

export default {
  data() {
    return {
      totalPageCount: 20,
      pagerLength: 11,
      counts: [1000, 100, 10],
    };
  },
  mounted() {
  },
  methods: {
    onPageChanged(index) {
      console.log(index);
    },
    onCountClick(count) {
      this.totalPageCount = count;
    },
  }
};
</script>

<style scoped>
.row {
  margin: 5px;
}
.btn {
  width: 60px;
  height: 24px;
  background-color: #22A;
  color: white;
  display:block;
}
</style>
